import React from "react";
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";
import CHFAQBody from "./Components/BodyFAQ";

class CHFAQ extends React.Component {
  render() {
    return (
      <>
        <Nav />
        <CHFAQBody />
        <Footer />
      </>
    );
  }
}

export default CHFAQ;
